import { React, useEffect, useState } from "react";

import { ProductController } from "controllers";
import ProductCard from "shared/components/product-card/product-card";

const ClosetPreview = () => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);

    const handleDelete = async (barcode) => {
        if (!window.confirm('Are you sure you want to remove this product from the preview?')) {
            return;
        };
        const payload = { is_preview: false };
        await ProductController.updateProductFields({ barcode, payload });
        const newProduct = products.filter(p => p.barcode !== barcode);
        setProducts(newProduct);
    };

    useEffect(() => {
        const getData = async () => {
            const data = await ProductController.getClosetPreviewProducts();
            setProducts(data);
        };

        if (products.length === 0) {
            getData();
            setLoading(false);
        }
    }, [products]);

    const RenderView = () => {
        if (loading) {
            return (
                <progress className="progress is-large is-primary" max="100">15%</progress>
            );
        }

        if (products.length === 0) {
            return (
                <article className="message is-info p-6">
                    <div className="message-body">
                        No products.
                    </div>
                </article>
            );
        }

        return (
            <div className="columns is-mobile is-multiline">
                {products.map(product => (
                    <div className="column is-one-quarter">
                        <ProductCard key={product.barcode} product={product} removeProduct={handleDelete} />
                    </div>
                ))}
            </div >
        )
    }

    return (
        <div className="container">
            <nav className="level">
                <div className="level-right">
                    <div className="level-item">
                        <div>
                            <h1 className="title">Closet Preview</h1>
                            <h2 className="heading is-2">All the pictures that the customers can preview before subscribing.</h2>
                        </div>
                    </div>
                </div>
            </nav>
            <RenderView />
        </div>
    );
}

export default ClosetPreview;
